// @flow
export const INPUT_THEME_API = {
  input: '',
  disabled: '',
  errored: ''
};
